import { render, staticRenderFns } from "./identity.vue?vue&type=template&id=68d1c7c6"
import script from "./identity.vue?vue&type=script&lang=js"
export * from "./identity.vue?vue&type=script&lang=js"
import style0 from "./identity.vue?vue&type=style&index=0&id=68d1c7c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports